import { apiUrl } from './client';

const authHeaders = () => {
  const sessionToken = sessionStorage.getItem('token') || '';
  const persistentToken = localStorage.getItem('token_persistent') || '';
  const legacyToken =
    sessionStorage.getItem('legacy_token') ||
    localStorage.getItem('token') ||
    '';
  const token = sessionToken || persistentToken || legacyToken;
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const activeGroupId = sessionStorage.getItem('active_group_id') || '';
  if (activeGroupId && Number.isFinite(Number(activeGroupId))) {
    headers['X-Active-Group-Id'] = String(activeGroupId);
  }
  return headers;
};

const createApiError = (status, message, payload) => {
  const error = new Error(message);
  error.status = status;
  if (payload !== undefined) {
    error.payload = payload;
  }
  return error;
};

const handleJson = async response => {
  if (!response.ok) {
    let message = `HTTP ${response.status}`;
    let payload;
    try {
      payload = await response.json();
      message = payload.error || message;
    } catch {
      // ignore
    }
    throw createApiError(response.status, message, payload);
  }
  return response.json();
};

export const draftsApi = {
  async getCurrent({ templateId } = {}) {
    const query = templateId ? `?templateId=${encodeURIComponent(templateId)}` : '';
    const res = await fetch(apiUrl(`drafts/current${query}`), {
      headers: { ...authHeaders() },
    });
    return handleJson(res);
  },

  async saveCurrent({ templateId = null, data, lastSyncedAt } = {}) {
    const payload = {
      templateId,
      data,
      lastSyncedAt,
    };
    const res = await fetch(apiUrl('drafts/current'), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders(),
      },
      body: JSON.stringify(payload),
    });
    return handleJson(res);
  },

  async clearCurrent({ templateId } = {}) {
    const query = templateId ? `?templateId=${encodeURIComponent(templateId)}` : '';
    const res = await fetch(apiUrl(`drafts/current${query}`), {
      method: 'DELETE',
      headers: { ...authHeaders() },
    });
    return handleJson(res);
  },
};
